import type { Theme } from '@polyu-dip/theme'

export const colors: Theme['colors'] = {
  primary: '#033f63', // Blue color, main titles
  accent: '#c95d63', // Chestnut Rose, Pink / PinkRed, for important buttons
  secondary: '#3B88C6', // light blue. For selections / highlights
  tertiary: '#E9F1F7', // even ligher blue. For backgrounds
}
